import store from './store';
import { createSelector } from 'reselect';

const uiState = (state) => state.ui;
const jobsState = (state) => state?.jobs;
export const getDialogSize = createSelector([uiState], (uiState) => ({ width: uiState.width, height: uiState.height }));
export const getWidth = createSelector([uiState], (uiState) => uiState.width);
export const getHeight = createSelector([uiState], (uiState) => uiState.height);
export const isJobPending = createSelector(
  [
    jobsState,
    (state, jobRoot, flowId = getSelectedFlow(), tenantId = getTenantId()) => ({ jobRoot, flowId, tenantId }),
  ],
  (jobs, { jobRoot, flowId, tenantId }) => jobs?.polling?.[`${flowId}/${tenantId}`]?.[jobRoot]
);
export const getActiveJobType = createSelector(
  [
    jobsState,
    (state, tenantId, flowId, entityId) => ({ tenantId, flowId, entityId }),
  ],
  (jobs, { tenantId, flowId, entityId }) => jobs?.activeJobTypes?.[`${tenantId}/${flowId}/${entityId}`]
);
// APIS

export function getApiUrl() {
  const state = store.getState();
  return state.configuration.api_url;
}

export function getApiKey() {
  const state = store.getState();
  return state.configuration.api_key;
}

export function getEnvId() {
  const state = store.getState();
  return state.configuration.env_id;
}

export function getTenantId() {
  const state = store.getState();
  return state.configuration.tenant_id;
}

export function getListener() {
  const state = store.getState();
  return state.configuration.listener;
}

export function getJwtToken() {
  const state = store.getState();
  return state.configuration.jwtToken;
}

export function getLocalization() {
  const state = store.getState();
  return state.configuration.localization;
}

export function getMultipleSources() {
  const state = store.getState();
  return state.configuration.multipleSources;
}

export function getMultipleConnectors() {
  const state = store.getState();
  return state.configuration.multipleConnectors;
}

export function corsCheck() {
  const state = store.getState();
  return state.configuration.corsCheck;
}

export function getSelectedFlow() {
  const state = store.getState();
  return state.flows.selectedFlow;
}

export function getSelectedSource() {
  const state = store.getState();
  return state.sources.selectedSource;
}

export function supportedFlow(flowId) {
  const { flows } = store.getState();
  return flows.supportedFlows[flowId];
}

export function linkedFlow(flowId) {
  const { flows } = store.getState();
  return flows.linkedFlows[flowId];
}

export function getCallbackDomain() {
  const state = store.getState();
  return state.preferences.domain;
}

export function getCallbackDomainName() {
  const state = store.getState();
  return state.preferences.domainName;
}

export function getCallbackFavicon() {
  const state = store.getState();
  return state.preferences.favicon;
}

export function getRedirectUri() {
  const state = store.getState();
  return state.preferences.redirectUri;
}

export function getBgColor() {
  const state = store.getState()
  return state.preferences.bgColor
}

export function getHideText() {
  const state = store.getState()
  return state.preferences.hideText
}

export function selectSourceById(sourceId) {
  const { sources } = store.getState();
  if (!sources.available) return undefined;

  return sources.available.filter((source) => source.tap == sourceId)[0];
}

export function selectSupportedSourceById(sourceId, flowId = getSelectedFlow()) {
  const { sources } = store.getState();
  if (!sources.supported) return undefined;

  return sources.supported[flowId][sourceId];
}

export function selectSupportedConnectorById(connectorId, flowId = getSelectedFlow()) {
  const { connectors } = store.getState();

  if (!connectors.supported) return undefined;

  return connectors.supported[flowId][connectorId];
}

export function selectSupportedTargetById(targetId, flowId = getSelectedFlow()) {
  const { targets } = store.getState();
  if (!targets.supported) return undefined;

  return targets.supported[flowId][targetId];
}

export function getCredentialsFormValidator() {
  const state = store.getState();
  return state.configuration.credentialsFormValidator;
}

export function selectLinkedSourceById(sourceId) {
  const { sources } = store.getState();
  return sources.linked && sources.linked[sourceId];
}

export function selectLinkedTargetById(targetId) {
  const { targets } = store.getState();
  return targets.linked && targets.linked[targetId];
}

export function selectLinkedConnectorById(connectorId) {
  const { connectors } = store.getState();
  return connectors.linked && connectors.linked[connectorId];
}

export function supportedSourcesForFlow(flowId = getSelectedFlow()) {
  const targetFlow = supportedFlow(flowId);
  return targetFlow.taps.map(selectSourceById);
}

export function linkedSourcesForFlow(flowId = getSelectedFlow()) {
  const targetFlow = linkedFlow(flowId);
  return targetFlow.taps.map(selectSourceById);
}

export function getLinkedEntities() {
  const { sources } = store.getState();
  return sources.linkedList || [];
}

export function initializationFinished() {
  const state = store.getState();

  return state.flows.supportedFlows && state.preferences.loaded;
}

export function selectMultipleTenantLink() {
  const state = store.getState();

  return state.preferences.multipleTenantLinks ?? false;
}

export function getSelectedEntity() {
  const state = store.getState();

  return state.entities.selectedEntity;
}

export function skipCallbackOAuthErrors() {
  const state = store.getState();

  return state.preferences.skipCallbackOAuthErrors ?? false;
}

export function subtenantDelimiter() {
  const state = store.getState();

  return state.preferences.featureFlags?.subtenantDelimiter ?? '_';
}

export function isJwtTokenStrict() {
  const state = store.getState();
  return state?.preferences?.jwtStrict ?? false;
}